import EmployeesApi from "../../apis/Employees";

export default {
  namespaced: true,
  state: {
    employees: [],
    workers: [],
    file_employees: null,
  },
  mutations: {
    set_employees(state, employees) {
      state.employees = employees;
    },
    set_workers(state, data) {
      state.workers = data;
    },
    set_file_employees(state, value) {
      state.file_employees = value;
    },
  },
  actions: {
    emptyFileSales({ commit }, value) {
      commit("set_file_employees", value);
    },
    async getEmployees({ commit, dispatch }, filters) {
      return await EmployeesApi.get_all(filters)
        .then((response) => {
          commit("set_employees", response.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al listar registros, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async store({ dispatch }, employee) {
      return await EmployeesApi.store(employee)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "El registro se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getEmployees");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al registrar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async update({ dispatch }, employee) {
      console.log(employee.registroPOrH);
      return await EmployeesApi.update(employee)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La actualización se realizó de forma correcta",
            },
            { root: true }
          );
          dispatch("getEmployees");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al actualizar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async change_status({ dispatch }, employee) {
      let action = employee.active ? "inactivación" : "activación";
      return await EmployeesApi.change_status(employee)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La " + action + " se relizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getEmployees");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al realizar la " +
                action +
                ", vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async delete({ dispatch }, employee) {
      return await EmployeesApi.delete(employee)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La eliminación se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getEmployees");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al eliminar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async getWorkers({ commit, dispatch }, filters) {
      return await EmployeesApi.get_worker(filters)
        .then((response) => {
          commit("set_workers", response.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al listar trabajadores, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async bajaEmpleado({ dispatch }, employee) {
      return await EmployeesApi.bajaEmpleado(employee)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "El registro se realizó de forma correcta.",
            },
            { root: true }
          );
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch("notifications/store_notification", {
            type: "error",
            message:
              "Ocurrió un error al dar de baja al amepleado, vuelva a intentarlo.",
          });
        });
    },
    async employeeDownload({ commit, dispatch }) {
      commit("set_file_employees", null);

      return await EmployeesApi.employeeDownload()
        .then((response) => {
          // console.log(response);
          commit("set_file_employees", response.data.file_name);
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "Se descargo reporte correctamente",
            },
            { root: true }
          );
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch("notifications/store_notification", {
            type: "error",
            message: "Ocurrió un error al descargar reporte",
          });
        });
    },
  },
};
